import type { Item } from "@/api_client";
import { useCatBreeds } from "@/hooks/api/useCatBreeds";

import {
  type AutocompleteFieldProps,
  ComposedAutoComplete,
} from "../composedAutoComplete/ComposedAutoComplete";
import { useAutoComplete } from "../composedAutoComplete/hooks/useAutoComplete";

interface CatBreedAutoCompleteProps
  extends Omit<
    AutocompleteFieldProps,
    | "setQuery"
    | "suggestions"
    | "onSuggestionSelected"
    | "onChange"
    | "inputValue"
    | "value"
  > {
  onChange?: (value: string) => void;
  value?: string | number | null;
}

export const CatBreedAutoComplete = ({
  onChange,
  errorMessage,
  name,
  children,
  value,
  placeholder,
  dataTestid,
  ...rest
}: CatBreedAutoCompleteProps) => {
  const { data: catBreeds, isLoading: isLoadingCatBreeds } = useCatBreeds();
  const getLabel = (item: Item) => item?.value ?? "";
  const getValue = (item: Item) => item?.value ?? "";
  const getId = (item: Item) => item?.key ?? item?.value ?? "";
  const { query, setQuery, suggestions } = useAutoComplete(
    catBreeds?.items ?? [],
    value,
    getLabel,
    getValue,
    getId,
  );

  return (
    <ComposedAutoComplete
      errorMessage={errorMessage}
      isLoading={isLoadingCatBreeds}
      name={name}
      suggestions={suggestions ?? []}
      setQuery={setQuery}
      dataTestid={dataTestid}
      placeholder={placeholder}
      onSuggestionSelected={(suggestion) => {
        if (!onChange || !suggestion) {
          return;
        }
        setQuery(suggestion.label);
        onChange(suggestion.id?.toString() ?? "");
      }}
      inputValue={query}
      {...rest}
    >
      {children}
    </ComposedAutoComplete>
  );
};
